import Agent from '../Core/agent';

const BasketApi = {
    add: () => {
    },
    delete: (productId, basketId, coupon, paymentVariant) => {
        return Agent.post(
            `/api/v1/basket/${basketId}/delete`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },
    update: (productId, count, coupon, paymentVariant) => {

        const queryData = {
            coupon: coupon,
            count,
            paymentVariant
        };

        return Agent.post(
            `/api/v1/basket/${productId}/update`,
             JSON.stringify(queryData),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },
    coupon: async coupon => {
        const queryData = {
            action: 'coupon',
            coupon: coupon,
        };
        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            'data=' + JSON.stringify(queryData),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },

    cartData: async (coupon, paymentVariant) => {
        const queryData = {
            coupon,
            paymentVariant
        };
        return Agent.post(
            '/api/v1/basket/data',
            'data=' + JSON.stringify(queryData),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    },

    reject: async (basketId, coupon) => {
        return Agent.post(
            '/includes/modules/cart/cart_functions.php',
            new window.URLSearchParams({
                action: "reject",
                basket_id: basketId,
                coupon: coupon
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    }
};
export default BasketApi;